<template>
  <div>
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      :evalTestId="evalTestId"
      message="¿Esta seguro de regresar el proceso al flujo?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />

    <app-table :id="tableId" :options="options" @action="getListAction" />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../../apiUrl";
import { TabLockedHelpers } from "../helpers/TabLockedHelpers";

export default {
  extends: CoreLibrary,
  name: "TabLocked",
  mixins: [TabLockedHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      evalTestId: "",
      tableId: "proforma-paymnet-locked",
      rowData: {},
      options: {
        url: `${actions.ACCREDITATION_PROCESS}/quotation/proforma/212`,
        name: this.$t("demo_crud"),
        columns: [],
        actions: [
          {
            title: this.$t("Regresar al proceso anterior."),
            icon: "edit-2",
            type: "modal",
            modalId: "proforma-lock-modal",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.$hub.$on("reload-table", () => {
      this.$hub.$emit("reload-" + this.tableId);
    });
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#proforma-lock-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.evalTestId = rowData.id;
      this.deleteConfirmationModalActive = true;
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      this.deleteLoader = true;
      // regresar al flujo anterior - estado 204
      const urlReturnStatus = `${actions.ACCREDITATION_PROCESS}/returnEvalStatus/${this.evalTestId}`;
      this.axiosGet(urlReturnStatus).then((response) => {
        console.log(response);
        if (response.data.status == true) {
          this.$toastr.s(response.data.data);
          window.location.href = `${actions.ACCREDITATION_PROCESS}/quotation?tab=Proformas%20bloqueadas`;
        } else {
          this.$toastr.e(response.data.data);
        }
      });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    data() {
      this.preloader = true;
    },
  },
};
</script>
